import * as httpHolder from './httpHolder';

export function login(username, password) {
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);
    formData.append('useAuthToken', true);

    return httpHolder.getInstanceForLogin().post('/connect/services/login', formData);
}

export function getCurrentUser() {
    return httpHolder.getInstance().get('/connect/services/users/currentUser', { withCredentials: true });
}



// WEBPACK FOOTER //
// ./src/services/apis/calAmp/authenticationServices.js